<template>
    <div>
        <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
        <div class="container container_grade container_com-fundo container_com-margem">
            <form @submit.prevent="salvarAporte">
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_12">
                        <h2 class="titulo titulo_grande">Preencha os campos abaixo para cadastrar o aporte</h2>
                    </div>
                    <div class="grade__coluna grade__coluna_6">
                        <h3 class="subtitle is-5 u-margem-superior-pequena">
                            Adicione o valor do aporte para o projeto <strong>MCMV Cidades</strong>
                        </h3>
                    </div>
                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_2">
                        <label class="formulario__label" for="valor-do-aporte">Aporte</label>
                        <input id="valor-do-aporte" class="formulario__input destacar-campos" type="text"
                            placeholder="Insira o valor do aporte" v-mask="'money'" v-model="aporte.ValorDoAporte"
                            required @change="atualizarGrafico()" />
                    </div>
                    <div class="grade__coluna grade__coluna_4">
                        <label class="formulario__label">Município</label>
                        <select class="formulario__input" v-model="aporte.CidadeId" required>
                            <option v-for="cidade in cidades" :value="cidade.Id">
                                {{ cidade.Nome }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_2">
                        <label class="formulario__label" for="numero-da-emenda">Número da emenda</label>
                        <input id="numero-da-emenda" class="formulario__input destacar-campos" type="number"
                            placeholder="Insira o número da emenda" v-model="aporte.NumeroDaEmenda" required />
                    </div>
                    <div class="grade__coluna grade__coluna_2">
                        <label class="formulario__label" for="data-de-publicacao-da-emenda">Data de publicação da
                            emenda</label>
                        <input id="data-de-publicacao-da-emenda" class="formulario__input" type="date"
                            v-model="aporte.DataDePublicacaoDaEmenda" required />
                    </div>
                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_6">
                        <h3 class="subtitle is-5 u-margem-superior-pequena">
                            Defina o <strong>valor do subsídio</strong> que cada faixa representa
                        </h3>
                    </div>
                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_2"
                        v-for="(distribuicaoPorFaixa, index) in aporte.distribuicoesDoAportePorFaixa" :key="index">
                        <label :for="'subsidio-faixa-' + (index + 1)" class="formulario__label">
                            Subsídio da {{ distribuicaoPorFaixa.NomeDaFaixa }}
                        </label>
                        <input :id="'subsidio-faixa-' + (index + 1)" class="formulario__input destacar-campos"
                            type="text" :placeholder="'Insira o valor de subsídio da faixa ' + (index + 1)"
                            v-model="distribuicaoPorFaixa.ValorDoSubsidio" v-mask="'money'" required />
                    </div>
                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_6">
                        <h3 class="subtitle is-5 u-margem-superior-pequena">
                            Defina o <strong>valor do subsídio para terreno público doado</strong> que cada faixa representa
                        </h3>
                    </div>
                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_2"
                        v-for="(distribuicaoPorFaixa, index) in aporte.distribuicoesDoAportePorFaixa" :key="index">
                        <label :for="'subsidio-terreno-publico-faixa-' + (index + 1)" class="formulario__label">
                            Subsídio Terreno Público da {{ distribuicaoPorFaixa.NomeDaFaixa }}
                        </label>
                        <input :id="'subsidio-terreno-publico-faixa-' + (index + 1)" class="formulario__input destacar-campos"
                            type="text" :placeholder="'Insira o valor para terreno público da faixa ' + (index + 1)"
                            v-model="distribuicaoPorFaixa.ValorDoSubsidioTerrenoPublicoDoado" v-mask="'money'" required />
                    </div>
                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_6">
                        <h3 class="subtitle is-5 u-margem-superior-pequena">
                            Distribua a porcentagem para cada faixa. <strong>O total deve ser exatamente
                                100%.</strong>
                        </h3>
                    </div>
                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_6">
                        <div class="grade__linha"
                            v-for="(distribuicaoPorFaixa, index) in aporte.distribuicoesDoAportePorFaixa" :key="index">
                            <div class="grade__coluna grade__coluna_12">
                                <label :for="'percentual-faixa-' + (index + 1)" class="formulario__label">
                                    {{ distribuicaoPorFaixa.NomeDaFaixa }}
                                </label>
                                <input :id="'percentual-faixa-' + (index + 1)" class="formulario__input destacar-campos"
                                    type="number" placeholder="0% - 100%" v-model="distribuicaoPorFaixa.Percentual"
                                    required @change="atualizarGrafico()" />
                            </div>
                        </div>
                    </div>
                    <div class="grade__coluna grade__coluna_6 coluna-grafico">
                        <div class="grafico-container">
                            <canvas id="graficoAporte" width="290px" height="290px"></canvas>
                            <div v-if="graficoVisivel" class="grafico-de-aporte-legenda">
                                <ul>
                                    <li v-for="(legenda, index) in legendasDoGrafico" :key="index">
                                        <span class="figura" :style="{ background: legenda.Cor }"></span>
                                        <div class="legenda-texto">
                                            <span class="titulo">{{
                                                $moeda.formatar(legenda.ValorDoAporteNaFaixa)
                                            }}</span>
                                            <span>{{ legenda.DescricaoDaDistribuicaoPorFaixa }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="grade__linha">
                    <div class="grade__coluna grade__coluna_6">
                        <router-link :to="`/lista-de-aporte/${this.projeto.Id}`"
                            class="botao botao_cinza botao_medio">Cancelar</router-link>
                        <button type="submit"
                            class="botao botao_medio botao_cor-terciaria u-margem-esquerda-media">Inserir
                            aporte</button>
                    </div>
                </div>
            </form>
        </div>
        <MensagemFlutuante :mensagemVisivel="mensagemVisivel" :titulo="tituloMensagem" :estilo="estiloMensagem"
            :texto="textoMensagem" @close="fecharMensagem" />
    </div>
</template>

<script>
import Chart from "chart-js";
import AwesomeMask from 'awesome-mask';
import Loading from '../../shared/Loading';
import MensagemFlutuante from '../../shared/MensagemFlutuante';

export default {
    name: "formulario-de-aporte-do-mcmv-cidades",
    directives: { mask: AwesomeMask },
    components: { Loading, MensagemFlutuante },
    data() {
        return {
            projeto: {},
            aporte: {
                distribuicoesDoAportePorFaixa: []
            },
            cidades: [],
            loading: { visivel: false },
            mensagemVisivel: false,
            textoMensagem: '',
            estiloMensagem: '',
            tituloMensagem: '',
            grafico: null,
            legendasDoGrafico: []
        }
    },
    mounted() {
        this.inicializarGrafico();
    },
    created() {
        let projetoId = this.$route.params.projetoId;
        this.exibirCarregamento();
        this.$api.get("/Projeto/ObterDados", { projetoId: projetoId })
            .then((response) => {
                this.projeto = response.data;
                this.inicializardistribuicoesDoAportePorFaixa();
            })
            .catch((error) => {
                console.error("Erro ao obter dados do projeto:", error);
            });

        this.$api.get('/Cidade/')
            .then((response) => {
                this.cidades = [{ Id: null, Nome: 'Selecione um município' }, ...response.data];
            })
            .catch((error) => {
                console.error("Erro ao obter cidades:", error);
            }).finally(() => {
                this.esconderCarregamento();
            });
    },
    computed: {
        graficoVisivel() {
            return this.aporte.distribuicoesDoAportePorFaixa.some(faixa =>
                faixa.Percentual && faixa.Percentual > 0
            );
        }
    },
    methods: {
        inicializardistribuicoesDoAportePorFaixa() {
            if (!this.projeto.FaixasDoProjeto) {
                console.warn("Faixas do projeto não encontradas.");
                return;
            }

            this.aporte.distribuicoesDoAportePorFaixa = this.projeto.FaixasDoProjeto.map(faixa => ({
                FaixaId: faixa.Id,
                NomeDaFaixa: faixa.Nome,
                Percentual: null,
                ValorDoSubsidio: null,
                ValorDoSubsidioTerrenoPublicoDoado: null
            }));
        },
        salvarAporte() {
            let payload = {
                ProjetoDeSubsidioId: this.projeto.Id,
                CidadeId: this.aporte.CidadeId,
                NumeroDaEmenda: this.aporte.NumeroDaEmenda,
                DataDePublicacaoDaEmenda: this.aporte.DataDePublicacaoDaEmenda,
                ValorDoAporte: this.$moeda.removerFormatacao(this.aporte.ValorDoAporte),
                DistribuicoesDoAportePorFaixa: this.aporte.distribuicoesDoAportePorFaixa.map(distribuicaoPorFaixa => ({
                    FaixaId: distribuicaoPorFaixa.FaixaId,
                    Percentual: distribuicaoPorFaixa.Percentual,
                    ValorDoSubsidio: this.$moeda.removerFormatacao(distribuicaoPorFaixa.ValorDoSubsidio),
                    ValorDoSubsidioTerrenoPublicoDoado: this.$moeda.removerFormatacao(distribuicaoPorFaixa.ValorDoSubsidioTerrenoPublicoDoado)
                }))
            };

            this.exibirCarregamento('Só um momento, estamos cadastrando o novo aporte...');
            this.$api.post('/Projeto/AportarNoMcmvCidades', payload).then(() => {
                this.exibirMensagemDeSucesso('Aporte salvo com sucesso');
                setTimeout(() => { this.redirecionarParaListagem(); }, 2000);
            }).catch((error) => {
                this.tratarErro(error);
            }).finally(() => {
                this.esconderCarregamento();
            });
        },
        exibirCarregamento(mensagem) {
            this.loading.visivel = true;
            this.loading.mensagem = mensagem;
        },
        esconderCarregamento() {
            this.loading.visivel = false;
            this.loading.mensagem = null;
        },
        tratarErro(error) {
            const internalServerError = 500;
            const mensagensDeErro = error.response.status != internalServerError ? error.response.data.Message : '';
            let mensagem;

            if (mensagensDeErro)
                mensagem = mensagensDeErro.split(',').join('<br />');
            else
                mensagem = 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';

            this.exibirMensagemDeErro(mensagem);
        },
        exibirMensagemDeSucesso(mensagem) {
            let estiloDaMensagem = 'sucesso';
            let tituloDaMensagem = 'Concluído'
            this.exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem);
        },
        exibirMensagemDeErro(mensagem) {
            let estiloDaMensagem = 'erro';
            this.exibirMensagem(mensagem, estiloDaMensagem);
        },
        exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
            this.mensagemVisivel = true;
            this.textoMensagem = mensagem;
            this.estiloMensagem = estiloDaMensagem;
            this.tituloMensagem = tituloDaMensagem || '';
            setTimeout(() => { this.fecharMensagem() }, 10000);
        },
        fecharMensagem() {
            this.mensagemVisivel = false;
        },
        inicializarGrafico() {
            const labels = this.aporte.distribuicoesDoAportePorFaixa.map(faixa => faixa.NomeDaFaixa);
            const dataset = {
                data: this.aporte.distribuicoesDoAportePorFaixa.map(faixa => faixa.Percentual || 0),
                backgroundColor: ['rgba(148, 32, 0, 1)', 'rgba(199, 63, 25, 1)', 'rgba(255, 206, 193, 1)']
            };

            this.grafico = this.criarGrafico(labels, dataset, "graficoAporte");
        },
        atualizarGrafico() {
            if (!this.grafico) return;

            this.grafico.data.datasets[0].data = this.aporte.distribuicoesDoAportePorFaixa.map(faixa => faixa.Percentual || 0);
            this.grafico.data.labels = this.aporte.distribuicoesDoAportePorFaixa.map((faixa) => faixa.NomeDaFaixa);
            this.legendasDoGrafico = this.aporte.distribuicoesDoAportePorFaixa.map((faixa, index) => ({
                Cor: this.grafico.data.datasets[0].backgroundColor[index] || '#ccc',
                ValorDoAporteNaFaixa: this.$moeda.removerFormatacao(this.aporte.ValorDoAporte || 0) * ((faixa.Percentual || 0) / 100),
                DescricaoDaDistribuicaoPorFaixa: `Faixa ${index + 1}: ${faixa.Percentual || 0}%`
            }));

            this.grafico.update();
        },
        criarGrafico(labels, dataset, chartId) {
            const myChart = document.getElementById(chartId).getContext("2d");
            return new Chart(myChart, {
                type: "doughnut",
                data: {
                    labels: labels,
                    datasets: [dataset],
                },
                options: {
                    cutoutPercentage: 60,
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        position: "right",
                        display: false,
                        fullWidth: false
                    },
                    animation: {
                        animateScale: true,
                        animateRotate: true,
                    },
                    tooltips: {
                        callbacks: {
                            label(tooltipItem, data) {
                                const valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                const labelDaFaixa = data.labels[tooltipItem.index] + ': ';
                                return labelDaFaixa + valor + '%';
                            },
                        },
                    },
                },
            });
        },
        redirecionarParaListagem() {
            this.$router.push(`/lista-de-aporte/${this.projeto.Id}`)
        }
    }
}
</script>


// WEBPACK FOOTER //
// CadastroDeAporte.vue?84b8faac